import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { myListsSelector } from 'selectors/page/myLists/myListsSelector';
import { lovesSelector } from 'selectors/loves/lovesSelector';
import myListsUtils from 'utils/MyLists';
import LoveActions from 'actions/LoveActions';
const { wrapHOC } = FrameworkUtils;

const fields = createSelector(userSelector, myListsSelector, lovesSelector, (user, myLists, loves) => {
    const isSharableListEnabled = myListsUtils.isSharableListEnabled();

    return {
        user,
        myLists,
        ...(isSharableListEnabled && { loves })
    };
});

const functions = dispatch => ({
    getAllLists: ({ profileId }) => {
        const action = LoveActions.getAllLists(profileId);
        dispatch(action);
    },
    fetchAllLovedItems: ({ force } = {}) => {
        const action = LoveActions.getFlatLoveListSkusWithDetails({ force });
        dispatch(action);
    }
});

const withInlineLovesProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withInlineLovesProps
};
